import React from "react";
import { useLanguage } from "../i18n/LanguageContext";

function Workflow() {
  const { t } = useLanguage();

  return (
    <section id="workflow" className="workflow-section">
      <div className="workflow-header">
        <div className="story-tag">{t.workflow.tag}</div>
        <h2>{t.workflow.title}</h2>
        <p>{t.workflow.description}</p>
      </div>
      <ol className="workflow-steps">
        {t.workflow.steps.map((step, i) => (
          <li key={step.title}>
            <span className="step-badge">{i + 1}</span>
            <div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}

export default Workflow;
